export enum Status {
  AGUARDANDO = 'AGUARDANDO',
  APROVADA = 'APROVADA',
  REPROVADA = 'REPROVADA',
  PAGO = 'PAGO',
  DISPONIVEL = 'DISPONIVEL',
  FINALIZADO = 'FINALIZADO',
  RESPONDIDO = 'RESPONDIDO',
  PAID = 'paid',
  APPROVED = 'approved',
  PENDING = 'pending',
  RENOVADO = 'RENOVADO',
  FAILED = 'failed',
  REJECTED = 'rejected',
  AGUARDANDO_RESPOSTA = 'AGUARDANDO_RESPOSTA',
  CANCELLED = 'cancelled'
}
